import React, { useState, useEffect } from 'react';
import "./oilgaspro.css";
import Sidebar from '../../../Components/Sidebar/Sidebar';
import oilgas1 from "../../../Assets/oil-gas-project.jpg"
import { Link } from 'react-router';
import oilgas2 from "../../../Assets/sound-barrier-india.webp";
import oilgas3 from "../../../Assets/oil-projects/modern-oil-factory-territory.jpg";
import oilgas4 from "../../../Assets/sound-barrier-manufacturer.webp";
import oilgas5 from "../../../Assets/oil-projects/oil-a1.jpg";
import oilgas6 from "../../../Assets/oil-projects/oil-a2.jpg";
import oilgas7 from "../../../Assets/oil-projects/oil-a3.jpg";
import oilgas8 from "../../../Assets/oil-projects/oil-a4.jpg";
import oilgas9 from "../../../Assets/oil-projects/oil-a5.jpg";
import oilgas10 from "../../../Assets/oil-projects/oil-a6.jpg";
import oilgas11 from "../../../Assets/oil-projects/oil-a7.jpg";
import HNavbar from '../../../Components/Navbar/HNavbar';
import MFooter from '../../../Components/Main-Footer/MFooter';


function OilGasProjects() {
    const [showTopBtn, setShowTopBtn] = useState(false);

    const handleClick = () => {
        const name = document.getElementById('name').value.trim();
        const mail = document.getElementById('mail').value.trim();
        const phone = document.getElementById('phone').value.trim();
        const message = document.getElementById('message').value.trim();

        const subject = `New message from ${name}`
        const body = `Name: ${name}%0AEmail: ${mail}%0APhone: ${phone}%0A%0AMessage:%0A${message}`;
        const mailtoLink = `mailto:mail@acousticalsurfaces.in?subject=${encodeURIComponent(subject)}&body=${body}`;

        window.open(mailtoLink, '_blank');

        document.getElementById('name').value = '';
        document.getElementById('mail').value = '';
        document.getElementById('phone').value = '';
        document.getElementById('message').value = '';
    }
    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 400) {
                setShowTopBtn(true);
            } else {
                setShowTopBtn(false);
            }
        };
        window.addEventListener('scroll', handleScroll);

        return () => window.removeEventListener('scroll', handleScroll);
    }, []);
    useEffect(() => {
        const animatedElements = document.querySelectorAll('.oil-header,.oil-header1,.oil-header2,.oil-header3,.oil-header4, .oil-header5,.oil-header6');

        const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('animate');
                } else {
                    entry.target.classList.remove('animate');
                }
            });
        }, { threshold: 0.3 });

        animatedElements.forEach(el => observer.observe(el));

        return () => {
            animatedElements.forEach(el => observer.unobserve(el));
        };
    }, []);
    return (
        <>
        <HNavbar />
            <section id='oil-gas' className='home-oil'>
                <div className='container p-0'>
                    <Sidebar />
                    <div className='row main-oil'>
                        <div className='col-12 col-md-6 d-flex justify-content-center align-items-center p-3'>
                            <div className='image-wrapper'>
                                <img className='img-fluid oil-home-img' src={oilgas1} alt="Oil-gas" />
                            </div>
                        </div>
                        <div className='col-12 col-md-6 d-flex flex-column justify-content-center align-items-start text-white'>
                            <h1 className='oil-header'>Oil and Gas Projects Noise Control Solutions | Sound Barrier</h1>
                            <p className='white-para'>Oil and gas projects generate high levels of industrial noise from drilling equipment, generators, compressors, and heavy machinery. Sound Barrier Manufacture provides professional sound barrier noise control solutions specially designed for oil and gas field applications.</p>
                            <p className='white-para'>Our high-performance sound barrier blankets and temporary acoustic enclosures help reduce noise transmission outside the project site and prevent public disturbance.</p>
                            <Link to="/contact"><button className='btn' type="button">Contact us</button></Link>
                        </div>
                    </div>
                </div>
            </section >
            <section id='oil-gas'>
                <div className='container noice-control mt-4'>
                    <h1 className='oil-header1'>Why Noise Control is Important in Oil and Gas Projects</h1>
                    <p>Oil and gas operations often take place near public zones, residential areas, or sensitive industrial facilities. Excessive noise can cause:</p>
                    <div className='row'>
                        <div className='col-sm-12 col-md-6'>
                            <img className='img-fluid' src={oilgas2} alt="Oil-gas" style={{ height: "500px" }} />
                        </div>
                        <div className='col-sm-12 col-md-6 d-flex flex-column align-items-center justify-content-center'>
                            <ul className='list'>
                                <li>Public disturbance complaints</li>
                                <li>Regulatory compliance issues</li>
                                <li>Worker health risks</li>
                                <li>Environmental noise violations</li>
                            </ul>
                        </div>
                    </div>
                    <p>Installing proper noise control systems helps maintain safe and controlled operations.</p>

                    <h1 className='oil-header2' style={{ marginTop: "10px" }}>Our Oil and Gas Sound Barrier Solutions</h1>
                    <p>Sound Barrier Manufacture supplies heavy-duty sound barrier blankets designed for outdoor and industrial environments.</p>
                    <div className='row mt-5'>
                        <div className='col-sm-12 col-md-6'>
                            <h5>Key Features:</h5>
                            <ul className='list'>
                                <li>High STC-rated sound barrier material</li>
                                <li>Weather-resistant and durable outer covering</li>
                                <li>Oil, dust, and moisture resistant</li>
                                <li>Easy to install on fencing or steel structures</li>
                                <li>Fire-retardant options available</li>
                                <li>Reusable and long service life</li>
                            </ul>
                            <p>Our acoustic sound blankets are ideal for temporary and semi-permanent industrial noise control.</p>
                        </div>
                        <div className='col-sm-12 col-md-6'>
                            <img className='img-fluid' src={oilgas3} alt="oil-gas" style={{ height: "400px" }} />
                        </div>
                    </div>

                    <h1 className='oil-header3' style={{ marginTop: "30px" }}>Benefits of Using Sound Barriers in Oil and Gas Projects</h1>
                    <p>Using construction-grade sound barriers helps:</p>
                    <div className='row'>
                        <div className='col-sm-12 col-md-6'>
                            <img className='img-fluid' src={oilgas4} alt="oil-gas" />
                        </div>
                        <div className='col-sm-12 col-md-6 d-flex flex-column align-items-center
                         justify-content-center'>
                            <ul className='list'>
                                <li>Reduce noise pollution outside the site</li>
                                <li>Protect nearby communities</li>
                                <li>Improve workplace safety</li>
                                <li>Meet environmental noise standards</li>
                                <li>Enhance company reputation</li>
                            </ul>
                        </div>
                    </div>
                    <h1 className='oil-header4' style={{ marginTop: "20px" }}>Applications in Oil and Gas Fields</h1>
                    <h4 className='sub-title mt-3'>Our noise control solutions are suitable for:</h4>
                    <div className='row'>
                        <div className='col-sm-3 d-flex flex-column justify-content-center align-items-center'>
                            <img className='img-fluid app-circle-img' src={oilgas5} alt="Drilling rigs" />
                            <p>Drilling rigs</p>
                        </div>
                        <div className='col-sm-3 d-flex flex-column justify-content-center align-items-center'>
                            <img className='img-fluid app-circle-img' src={oilgas6} alt="Compressor stations" />
                            <p>Compressor stations</p>
                        </div>
                        <div className='col-sm-3 d-flex flex-column justify-content-center align-items-center'>
                            <img className='img-fluid app-circle-img' src={oilgas7} alt="Generator enclosures" />
                            <p>Generator enclosures</p>
                        </div>
                        <div className='col-sm-3 d-flex flex-column justify-content-center align-items-center'>
                            <img className='img-fluid app-circle-img' src={oilgas8} alt="Pump stations" />
                            <p>Pump stations</p>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-sm-4 d-flex flex-column justify-content-center align-items-center'>
                            <img className='img-fluid app-circle-img' src={oilgas9} alt="Refinery maintenance" />
                            <p>Refinery maintenance work</p>
                        </div>
                        <div className='col-sm-4 d-flex flex-column justify-content-center align-items-center'>
                            <img className='img-fluid app-circle-img' src={oilgas10} alt="Pipeline construction" />
                            <p>Pipeline construction projects</p>
                        </div>
                        <div className='col-sm-4 d-flex flex-column justify-content-center align-items-center'>
                            <img className='img-fluid app-circle-img' src={oilgas11} alt="Gas processing units" />
                            <p>Gas processing units</p>
                        </div>
                    </div>
                </div>
            </section>
            <section id='oil-gas' className='call'>
                <div className='container'>
                    <h1 className='oil-header5'>Why Choose Us?</h1>

                    <ul className='contact-list white-para'>
                        <li>Experienced acoustic solution provider</li>
                        <li>Industrial-grade sound barrier manufacturing</li>
                        <li>Custom size and thickness options</li>
                        <li>Quick supply and installation support</li>
                        <li>Cost-effective noise control systems</li>
                    </ul>
                    <p className='white-para'>We understand the challenges of industrial environments and provide reliable soundproofing solutions for oil and gas operations.</p>

                    <h1 className='oil-header6'>Contact Us for Oil and Gas Noise Control Solutions</h1>
                    <div className='row'>
                        <div className='col-sm-12 col-md-6 mt-2'>
                            <p className='white-para'>Looking for effective noise control solutions for your oil and gas project?</p>
                            <p className='white-para'>Sound Barrier Manufacture delivers high-performance sound barrier systems designed to control industrial noise and reduce public disturbance.</p>
                            <p className='white-para'>Contact us today for customized oil and gas noise control solutions.</p>
                        </div>
                        <div className='col-sm-12 col-md-6 p-0'>
                            <div className='row'>
                                <div className="col-sm-12 col-md-4 mb-3">
                                    <input
                                        type="text"
                                        name="name"
                                        id="name"
                                        className="form-control"
                                        placeholder="Name *"
                                    />
                                </div>
                                <div className="col-sm-12 col-md-4 mb-3">
                                    <input
                                        type="email"
                                        name="mail"
                                        id="mail"
                                        className="form-control"
                                        placeholder="Email *"
                                    />
                                </div>
                                <div className="col-sm-12 col-md-4 mb-3">
                                    <input
                                        type="text"
                                        name="phone"
                                        id="phone"
                                        className="form-control"
                                        placeholder="Phone *"
                                    />
                                </div>
                                <div className="col-12 mb-3">
                                    <textarea
                                        rows={4}
                                        id="message"
                                        className="form-control"
                                        placeholder="Message *"
                                    ></textarea>
                                </div>
                                <div className="col-12">
                                    <button
                                        className="btn"
                                        type="button"
                                        onClick={handleClick}
                                    >
                                        SEND
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {showTopBtn && (
                <button className='scroll-to-top'
                    onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                > ↑ </button>
            )}
            <MFooter />
        </>
    )
}

export default OilGasProjects